import Component from "../abstracts/Component";

export default class WishlistHeaderComponent extends Component {

    get SELECTORS() {
        return {
            qtyWishlist: '.wishlistCount'
        }
    }

    get CLASSES() {
        return {
            iconWishlistEmpty: "icon-wishlist-empty",
            iconWishlistFull: "icon-wishlist-full"
        }
    }

    constructor(el) {
        super(el);
        this.qtyWishlist = $(this.SELECTORS.qtyWishlist);
    }

    // change wishlist icon state on header
    updateWishlistIcon(qty) {
        if(parseInt(qty,10) > 0){
            this.qtyWishlist.addClass("isVisible")
        } else {
            this.qtyWishlist.removeClass("isVisible");
        }
        this.qtyWishlist.text(parseInt(qty,10));
        if (this.wishlistIcon != null) {
            if (parseInt(qty,10) > 0) {
                this.wishlistIcon.classList.remove(this.CLASSES.iconWishlistEmpty);
                this.wishlistIcon.classList.add(this.CLASSES.iconWishlistFull);
            } else {
                this.wishlistIcon.classList.remove(this.CLASSES.iconWishlistFull);
                this.wishlistIcon.classList.add(this.CLASSES.iconWishlistEmpty);
            }
        }
    }

    bindEvents() {
        this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
            // update wishlist counter
            this.updateWishlistIcon(parseInt(payload.qty,10));
        });
        this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
            // update wishlist counter
            this.updateWishlistIcon(parseInt(payload.totalCount,10));
        });
    }

    render() {
        console.log('Rendering WishlistHeaderComponent...');
        this.bindEvents();

        let wishlistCountValue = this.qtyWishlist && this.qtyWishlist.text();
        if (parseInt(wishlistCountValue,10) > 0) {
            this.qtyWishlist.addClass("isVisible");
        };
    }
};